<template>
  <div>
    <b-data-table
        :headers="headers"
        :items="billings"
        style="border: none"
        :page.sync="pagination.current_page"
        @page-sync="p => (pagination.current_page = p)"
        disable-sort
        :pagination="billingsPagination"
        :hide-default-footer="!billingsPagination.total"
    >
      <template v-slot:item.total="{ item }">
        {{
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2
          }).format(item.total)
        }}
      </template>

      <template v-slot:item.pending="{ item }">
        <v-alert
            :type="!['completed','failed'].includes(item.payment_status)?'warning':(item.payment_status == 'completed'&&'success'||'error')"
            class="ma-0"
            text
            dense
            outlined
        >
          {{ translations[item.payment_status || 'incomplete'][lang] }}
        </v-alert>
       
      </template>
      <template v-slot:item.payment_at="{ item }">
        <v-btn
            v-if="getPayBtnType(item) == 'stripe'"
            class="text-capitalize"
            depressed
            :disabled="loading"
            :loading="loading"
            color="secondary"
            v-text="translations.payNow[lang]"
            @click="payBilling(item)"
        >
        </v-btn>
        <span
            v-else-if="getPayBtnType(item) == 'payment_codes'"
            class="font-weight-bold"
        >{{ item.payment_identifier }}</span>
        <span v-else>{{ item.payment_at }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
                color="secondary darken-3"
                icon
                v-on="on"
                @click="viewBillingDetails(item)"
            >
              <v-icon v-text="icons.mdiTableEye"></v-icon>
            </v-btn>
          </template>
          <span
              class="font-weight-bold"
              v-text="translations.viewMore[lang]"
          ></span>
        </v-tooltip>
        <v-tooltip v-if="superUser" color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
                color="secondary darken-3"
                icon
                v-on="on"
                :loading="loadingBillingId==item.billing_id"
                @click="startCalculateBilling(item.billing_id)"
            >
              <v-icon v-text="icons.mdiReceiptTextEditOutline"></v-icon>
            </v-btn>
          </template>
          <span
              class="font-weight-bold"
              v-text="translations.calculateBilling[lang]"
          ></span>
        </v-tooltip>
      </template>
    </b-data-table>
    <v-dialog v-model="detailsDialog" max-width="500">
      <b-card
          :title="translations.billingDetails[lang]"
          @cancel="detailsDialog = false"
          :submitBtn="false"
      >

        <InvoiceTable :invoice="viewBilling&&viewBilling.invoice" :billing="viewBilling"/>

      </b-card>
    </v-dialog>
  </div>
</template>

<script>
import InvoiceTable from "@/components/general/settings/billingDashboard/InvoiceTable.vue";
import translations from "@/utils/translations/general/settings/billingDashboard";
import {mdiTableEye, mdiReceiptTextEditOutline} from "@mdi/js";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "BillingsTable",

  mixins: [translations],

  components: {InvoiceTable},

  props: ["billings", "pagination"],

  data() {
    return {
      icons: {mdiTableEye,mdiReceiptTextEditOutline},
      detailsDialog: false,
      viewBilling: null,
      loadingBillingId: null,
    };
  },

  computed: {
    ...mapState(["loading", "errorMessage", "superUser"]),

    ...mapState("general/settings/billingDashboard/paymentMethods", [
      "selectedMethod"
    ]),

    lang() {
      return this.$route.params.lang;
    },

    headers() {
      return [
        {
          text: this.translations.total[this.lang],
          value: "total",
          align: "center",

        },
        {
          text: this.translations.paymentStatus[this.lang],
          value: "pending",
          align: "center",

        },
        {
          text: this.translations.period[this.lang],
          value: "periodVal",
          align: "center",
        },
        {
          text: this.translations.payment_date[this.lang],
          value: "payment_at",
          align: "center"
        },
        {
          text: this.translations.actions[this.lang],
          value: "actions",
          align: "center",
        },
      ];
    },

    billingsPagination(){
      return this.pagination || null
    },
   
    page() {
      return  this.pagination?.current_page ;
    },
  },

  methods: {
    ...mapActions(
        "general/settings/billingDashboard/paymentHistory",
        ["billingPayment"]
    ),
    ...mapMutations(["setDeleteDialog", "setNotification", "setLoading"]),

    ...mapActions("general/settings/billingDashboard", [
      "fetchBillingDashboardData", "calculateBilling"
    ]),

    viewBillingDetails(item){
      this.detailsDialog = true
      this.viewBilling = item
    },
    async startCalculateBilling(id){
      try {
        
        this.loadingBillingId = id
        await this.calculateBilling(id)
        this.loadingBillingId = null
        this.setNotification({
            show: true,
            type: "success",
            text: this.translations.billingUpdated[this.lang]
        })
      } catch (error) {
        this.loadingBillingId = null
        console.log( 'error:',error.data)
        this.setNotification({
            show: true,
            type: "error",
            text: error.response?.data?.message || 'Error calculating billing'
        })
      }

    },

    async payBilling(billing) {
      const data = await this.billingPayment(billing.billing_id)
      if (data.code === 200) {
        billing.payment_completed = data.data.payment_completed
        billing.payment_at = data.data.payment_at
        this.fetchBillingDashboardData()
      }
    },

    getPayBtnType(item){
      return ['incomplete', 'failed'].includes(item.payment_status || 'incomplete') && this.selectedMethod && this.selectedMethod.system_payment_category.system
    }

  },

  watch: {
    viewBilling: {
      immediate: true,
      handler(val) {
        if (val && (typeof val.invoice == 'object') && val.invoice?.length === 0) {
          val.invoice = null
        }
      }
    }
  },
}

</script>

<style scoped>

</style>